module.exports = __webpack_public_path__ + "img/mobile-notification.2386abb7.svg";